// Implements: F-MCK-001, F-UIX-014, F-UIX-009, F-UIX-010
/**
 * `/lienzo` — the blank Lienzo (UX-04): where a mockup is created.
 *
 * The redesign mockup's editor with no mockup open: the conversation column holds the creation
 * hero ("¿Qué pantalla quieres crear?") and the preview side shows the empty canvas where the
 * first version will appear. Creating lands on `/lienzo/:id`, the same split with the mockup in
 * it, which follows the turn the creation started (OD-7). The create logic itself is
 * `MockupCreateContainer`'s: one paid call, never retried, in a scope chosen from the person's
 * seats.
 */

import type { ReactElement } from "react";

import { ScopeDesignChipContainer } from "../../modules/design/containers/ScopeDesignChipContainer";
import { MockupCreateContainer } from "../../modules/mockups/containers/MockupCreateContainer";
import { useTranslation } from "../../shared/i18n";
import { EmptyState } from "../../shared/ui/molecules/EmptyState";
import styles from "./LienzoPage.module.css";

export function LienzoPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      <h1 className={styles.srOnly} tabIndex={-1}>
        {t("lienzo.title")}
      </h1>
      <div className={styles.editor}>
        <section className={styles.conversation} aria-label={t("lienzo.hero.section")}>
          <div className={styles.head}>
            <h2 className={styles.headTitle}>{t("lienzo.newMockup")}</h2>
            <span className={styles.meta}>{t("lienzo.hero.subtitle")}</span>
          </div>
          <div className={styles.thread}>
            <section className={styles.hero} aria-labelledby="lienzo-hero-title">
              <h2 className={styles.heroTitle} id="lienzo-hero-title">
                {t("lienzo.hero.title")}
              </h2>
              <MockupCreateContainer designChip={(scope) => <ScopeDesignChipContainer scope={scope} />} />
            </section>
          </div>
        </section>
        <div className={styles.divider} aria-hidden="true" />
        <section className={styles.preview} aria-label={t("lienzo.canvas.label")}>
          <div className={styles.stage}>
            <EmptyState icon="canvas" title={t("lienzo.canvas.title")} body={t("lienzo.canvas.body")} />
          </div>
        </section>
      </div>
    </>
  );
}
